export const textSizeStyles = {
  sm: "text-xs",
  md: "text-sm",
} as const;
